/**
 * API Configuration - Dynamic base URL for development vs production
 *
 * In development: UI runs on port 5175 (Vite), server on port 7203
 * In production: Server serves the UI from wwwroot, same origin
 */

export const apiBase = window.location.hostname.includes("localhost")
  ? "https://localhost:7203"
  : window.location.origin;
